module.exports = __webpack_public_path__ + "img/consumption_green.5f226270.png";